module.exports = __webpack_public_path__ + "img/exercises.a77a33d6.svg";